import { render } from "./experienceResume.vue?vue&type=template&id=0f4d815d&scoped=true&ts=true"
import script from "./experienceResume.vue?vue&type=script&lang=ts"
export * from "./experienceResume.vue?vue&type=script&lang=ts"

import "./experienceResume.vue?vue&type=style&index=0&id=0f4d815d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4d815d"]])

export default __exports__